import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EmitterService } from '@service/emitter/emitter.service';
import { HonoraireService } from '@service/syndic/honoraire.service';
import { Globals } from '@theme/utils/globals';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { HonoraireAddComponent } from '../honoraire-add/honoraire-add.component';

@Component({
  selector: 'app-honoraire-list',
  templateUrl: './honoraire-list.component.html',
  styleUrls: ['./honoraire-list.component.scss']
})
export class HonoraireListComponent implements OnInit {
  @Input() honoraires: any[] = [];
  @Input() trusteeUuid: string = '';
  dtOptions: any = {};

  constructor(
    private modalService: NgbModal,
    private emitter: EmitterService,
    private honoraireService: HonoraireService
  ) {
    this.emitter.event.subscribe((data: any) => {
      if (data.action === 'HONORAIRE_ADD' || data.action === 'HONORAIRE_UPDATED') {
        this.loadData();
      }
    });
  }

  ngOnInit(): void {
    this.dtOptions = Globals.dataTable;
    this.loadData();
  }

  loadData(): void {
    if (this.trusteeUuid) {
      this.honoraireService.getList(this.trusteeUuid).subscribe((res: any) => {
        this.honoraires = res || [];
      });
    }
  }

  addHonoraire(): void {
    this.honoraireService.edit = false;
    this.honoraireService.setHonoraire(null);
    this.modal(HonoraireAddComponent, 'modal-basic-title', 'lg');
  }

  editHonoraire(row: any): void {
    this.honoraireService.edit = true;
    this.honoraireService.setHonoraire(row);
    this.modal(HonoraireAddComponent, 'modal-basic-title', 'lg');
  }

  deleteHonoraire(item: any): void {
    Swal.fire({
      title: 'Êtes-vous sûr ?',
      text: 'Cette action est irréversible !',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Oui, supprimer !',
      cancelButtonText: 'Non, annuler'
    }).then((result) => {
      if (result.isConfirmed) {
        this.honoraireService.getDelete(item.uuid).subscribe((res: any) => {
          if (res?.status === 'success') {
            this.loadData();
            Swal.fire({ icon: 'success', title: 'Succès', text: res?.message });
          }
        });
      }
    });
  }

  modal(component: any, type: string, size: string): void {
    const modalRef = this.modalService.open(component, {
      ariaLabelledBy: type, size: size, centered: true, backdrop: 'static'
    });
    modalRef.result.then((result) => {}, (reason) => {});
  }
}
